export default "__VITE_ASSET__BU1aJvL6__"